var ComponentView = require("../../view/Component");

var _default = ComponentView.extend({
  type: 'timeline'
});

module.exports = _default;


//////////////////
// WEBPACK FOOTER
// ../~/echarts/lib/component/timeline/TimelineView.js
// module id = 3fsE
// module chunks = 0